<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: String,
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        class=" focus:ring-accent-primary border border-solid border-gray-300 focus:border-accent-primary rounded-md shadow-sm p-1"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
</template>
